/**
 * Asynchronously loads the component for DormantCampaignsLeadsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DormantCampaignsLeadsPage = lazyLoad(
  () => import('./index'),
  module => module.DormantCampaignsLeadsPage,
);
